import React, { FunctionComponent, useCallback } from 'react';
import ServicePlansSection from './servicePlansSection/ServicePlansSection';
import { useDispatch, useSelector } from 'react-redux';
import optionsSelectors from '../../../../store/selectors/optionsSelectors';
import useAccordionStoreState from '../../../../react/useAccordionStoreState';
import { carConfigurationActions } from '../../../../store/reducers/carConfigurationReducer';
import { CustomiseSections } from '../../../../../common/enum/CustomiseSections';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import ScrollToWrapper from '../../../presentational/ScrollToWrapper';
import { Box } from '@material-ui/core';
import thunkActions from '../../../../store/actions/thunkActions';
import useGetPostCode from '../../../../../common/react/useGetPostCode';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import { useParams } from 'react-router';
import configurationSourceUrlService from '../../../../service/configurationSourceUrlService';
import useWidgetContext from '../../../../../common/react/useWidgetContext';
import IParams from '../../../../../gqlCustomise/model/IParams';
import useCustomerStorage from '../../../../../common/hooks/useCustomerStorage';

const ServicePlansContainer: FunctionComponent = () => {
  const options = useSelector(optionsSelectors.getOptions);
  const { expanded, setExpanded } = useAccordionStoreState(CustomiseSections.SERVICE_PLAN);
  const optionsLoading = useSelector(optionsSelectors.getOptionsLoadingState);
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const selectedServicePlan = useSelector(carConfigurationSelectors.getSelectedServicePlan);
  const dispatch = useDispatch();
  const postcode = useGetPostCode();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const car = useSelector(carConfigurationSelectors.getCustomisedCar);
  const { modelId } = useParams<IParams>();
  const {
    configuration: { basePath, dimensions },
  } = useWidgetContext();
  const { customerStorage } = useCustomerStorage();

  const toggleServicePlan = useCallback(
    async (servicePlanId: string) => {
      let servicePlan: string | null;
      if (selectedServicePlan !== servicePlanId) {
        dispatch(carConfigurationActions.addServicePlan(servicePlanId));
        servicePlan = servicePlanId;
      }
      if (selectedServicePlan === servicePlanId) {
        dispatch(carConfigurationActions.removeServicePlan());
        servicePlan = null;
      }

      const dealerId = customerStorage.getCustomerData()?.dealerId || '';
      const { payload } = (await dispatch(
        thunkActions.initBasket({
          initRequest: {
            vehicleId: car.carId,
            vehicleAccessories: car.accessories || [],
            vehicleAccessoryPacks: car.packs || [],
            vehicleServicePlan: servicePlan,
            dealerId,
            postcode,
            configurationSourceUrl: configurationSourceUrlService.getUrl(basePath, modelId, car.carId, {
              ...car,
              servicePlan,
            }),
          },
          priceDisplay,
          dimensions,
        }),
      )) as any;
      if (payload) {
        // @TODO: Refactor when deal decoupled from basket.
        dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
      }
    },
    [selectedServicePlan, car, postcode, priceDisplay, modelId, basePath],
  );

  return (
    <Box data-test={'container:section:service_plans_wrapper'}>
      {Object.keys(options?.servicePlans?.items || {}).length > 0 && (
        <ScrollToWrapper target={CustomiseSections.SERVICE_PLAN} data-test={'container:section:service_plans'}>
          <ServicePlansSection
            error={optionsError}
            loading={optionsLoading}
            selectedServicePlan={selectedServicePlan}
            onClick={toggleServicePlan}
            servicePlans={options?.servicePlans?.items}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        </ScrollToWrapper>
      )}
    </Box>
  );
};

export default ServicePlansContainer;
